import type { LotCostSource } from "../api/types";

/**
 * WO-B (G-139, OD-198): how a lot's cost source reads on the office screens.
 * PRICED needs no label — a price someone typed or a supplier billed.
 */
export function lotCostSourceLabel(source: LotCostSource): string | null {
  switch (source) {
    case "PRICED":
      return null;
    case "ESTIMATED_LAST_LOT":
      return "Estimated · last delivery";
    case "ESTIMATED_CATALOG":
      return "Estimated · catalogue";
    case "UNKNOWN":
      return "Cost unknown";
  }
}
